import React from 'react'
import { bool, number, shape } from 'prop-types'
import classNames from 'classnames'

import {
  ANALYTICS_ATTR_IMAGE,
  ANALYTICS_ATTR_TITLE
} from 'shared/consts/crosssellWidgets'

import getProductUrl from 'shared/utils/getProductUrl'
import { ProductType, mountPointsType } from 'views/utils/propTypes'

import ProductPrice from 'views/components/organisms/ProductPrice'
import ButtonImage from 'views/components/molecules/ButtonImage'
import StarRating from 'views/components/molecules/StarRating'
import ImageWithDiscountBadge from 'views/components/molecules/ImageWithDiscountBadge'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'

import withMountPoints from 'views/enhancers/withMountPoints'

import { getAmount } from './helpers'

import './ProductSliderItem.scss'

const ProductSliderItem = ({
  product,
  thumbnail,
  lazyLoad,
  noBorder,
  whiteImageBg,
  srcWidth,
  srcHeight,
  mountPoints
}) => {
  const {
    id,
    canonicalURL,
    thumbnailURL,
    imageUrl,
    name,
    discount,
    rating,
    numberOfRatings,
    darreichung,
    prices
  } = product
  const className = classNames(
    'o-ProductSliderItem u-text-align--center u-padding--bottom',
    {
      'o-ProductSliderItem--no-border': noBorder,
      'o-ProductSliderItem--white-img-bg': whiteImageBg
    }
  )
  const amount = getAmount(product)
  const productUrl = getProductUrl(canonicalURL)

  return (
    <article className={className} data-product-id={id}>
      <header className="o-ProductSliderItem__header u-position--relative u-margin-x-small--bottom">
        <div
          className="o-ProductSliderItem__image u-margin-large--bottom"
          data-clientside-hook="slider__image"
        >
          <ButtonImage
            name={`product-slider-${id}-image-button`}
            href={productUrl}
            noBorder
            className="u-position--relative"
          >
            <ImageWithDiscountBadge
              imageUrl={thumbnailURL || imageUrl}
              srcWidth={srcWidth}
              srcHeight={srcHeight}
              alt={name}
              discountPercent={discount}
              thumbnail={thumbnail}
              lazyLoad={lazyLoad}
              imageAttrs={{
                'data-analytics': ANALYTICS_ATTR_IMAGE
              }}
            />
          </ButtonImage>
        </div>
        <h3
          className="a-p u-margin-x-small--bottom"
          data-clientside-hook="stretchVertically"
          data-stretch-group="name"
        >
          <ButtonAsLink
            href={productUrl}
            name={`product-slider-${id}-link-button`}
            className="o-ProductSliderItem__link"
            data-analytics={ANALYTICS_ATTR_TITLE}
          >
            {name}
          </ButtonAsLink>
        </h3>
        <StarRating
          rating={rating}
          ratingCount={numberOfRatings}
          centered
          invisible={!(rating > 0 || numberOfRatings > 0)}
          href={mountPoints.getProductReviews(productUrl)}
        />
      </header>
      <ul className="a-list-reset">
        <li
          data-clientside-hook="stretchVertically"
          data-stretch-group="amount"
        >
          {amount}
          {amount && darreichung && ' | '}
          {darreichung}
        </li>
        <li>
          <ProductPrice
            prices={prices}
            size="x-small"
            displayInfo={false}
            showSuperScript
          />
        </li>
      </ul>
    </article>
  )
}

ProductSliderItem.propTypes = {
  product: shape(ProductType).isRequired,
  thumbnail: bool,
  lazyLoad: bool,
  noBorder: bool,
  whiteImageBg: bool,
  srcWidth: number,
  srcHeight: number,
  mountPoints: mountPointsType.isRequired
}

ProductSliderItem.defaultProps = {
  thumbnail: false,
  lazyLoad: false,
  noBorder: false,
  whiteImageBg: false,
  srcWidth: 250,
  srcHeight: 250
}

export default withMountPoints(ProductSliderItem)
